import { Routes, Route } from "react-router-dom";

import "./App.css";

import MainPage from "./pages/MainPage/MainPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import InfoPage from "./pages/InfoPage/InfoPage";
import ProjectPage from "./pages/ProjectPage/ProjectPage";

const App = () => {
  return (
    <Routes>
      <Route path='/' element={<MainPage/>}></Route>
      <Route path='/info' element={<InfoPage/>}></Route>
      <Route path='/login' element={<LoginPage/>}></Route>
      <Route path='/:projectSlug' element={<ProjectPage/>}></Route>
    </Routes>
  );
};

export default App;
